/**
 * 条款页面
 */
export enum ProtocolPage {
  /**
   * 隐私政策
   */
  PRIVACY_POLICY = 'privacy_policy',
  /**
   * 购物条款
   */
  SHOPPING_TERMS = 'shopping_terms',
  TERMS = 'terms',
  /**
   * 會員計劃詳細
   */
  MEMBER_PLAN = 'member_plan',
  /**
   * 售后服务
   */
  AFTER_SALES = 'after_sales',
  /**
   * 條款及細則
   */
  TERMS_AND_CONDITIONS = 'terms_and_conditions',
}

export enum ProtocolPageId {
  PRIVACY_POLICY = 1,
  SHOPPING_TERMS = 2,
  // eslint-disable-next-line ts/no-duplicate-enum-values
  TERMS = 2,
  AFTER_SALES = 3,
  MEMBER_PLAN = 4,
  TERMS_AND_CONDITIONS = 5,
}
